import React from 'react';
import cx from 'classnames';
import styles from '@/common/components/Inputs/Select/styles.less';
import { Controller, useFormContext } from 'react-hook-form';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import { ReactBB } from '@/common/utils/bbParser/index';

const SelectInput = ({
  className,
  options = [],
  name,
  label,
  tip,
  required,
  inputFormat = 'yyyy/mm/dd',
  multiple = false,
  checkMarks = false,
  rules,
  ...props
}) => {
  const { control } = useFormContext() || {};

  return (
    <div className={cx(styles.container, className)}>
      <Controller
        defaultValue=""
        name={name}
        control={control}
        rules={rules}
        render={({
          field: { onChange, value, name },
          fieldState: { error },
        }) => (
          <>
            <InputLabel
              className={cx(styles.label, error && styles['label-error'])}
              htmlFor={name}
            >
              {ReactBB(label)}
              {required && <span className={styles.labelRequired}>*</span>}
            </InputLabel>
            <Select
              onChange={onChange}
              value={multiple && typeof value === 'string' ? [] : value}
              name={name}
              error={!!error}
              multiple={multiple}
              inputProps={{ ...props.inputProps, ['data-testid']: name }}
              fullWidth
              sx={{
                borderRadius: '4px',
                '& .MuiOutlinedInput-notchedOutline': {
                  borderRadius: '4px',
                },
                '& .MuiSelect-select.MuiOutlinedInput-input': {
                  padding: '16px 12px',
                  minHeight: '24px',
                  display: 'flex',
                  alignItems: 'center',
                },
              }}
              {...props}
            >
              {options.map(({ value: itemValue, label }) => (
                <MenuItem key={itemValue} value={itemValue}>
                  {checkMarks && (
                    <Checkbox checked={value.indexOf(itemValue) > -1} />
                  )}
                  {label}
                </MenuItem>
              ))}
            </Select>
            <InputLabel
              className={cx(
                styles.bottomLabel,
                !!error && styles['bottomLabel-error']
              )}
              htmlFor={name}
            >
              {error?.message || tip}
            </InputLabel>
          </>
        )}
      />
    </div>
  );
};

export default SelectInput;
